import React, { Component } from "react";
import CustomNotification from "../global/components/CustomNotification/CustomNotification";
import strings from "../global/constants/StringConstants";
import { globalEmitter } from "./emitter";

type NotificationState = {
  showNotification: boolean;
  variant: string;
  title: string;
  message: string;
};

class Notifications extends Component<{}, NotificationState> {
  state: NotificationState = {
    showNotification: false,
    variant: strings.success,
    title: "",
    message: "",
  };

  hideTimer: ReturnType<typeof setTimeout> | null = null;

  componentDidMount() {
    globalEmitter.addListener(
      strings.notification,
      this.handleNotificationEmitted
    );
  }

  componentWillUnmount() {
    globalEmitter.removeListener(
      strings.notification,
      this.handleNotificationEmitted
    );
    if (this.hideTimer) clearTimeout(this.hideTimer);
  }

  handleClose = () => {
    this.setState({ showNotification: false });
  };

  scheduleHide = (seconds = 4) => {
    if (this.hideTimer) clearTimeout(this.hideTimer);
    this.hideTimer = setTimeout(() => {
      this.handleClose();
    }, seconds * 1000);
  };

  handleNotificationEmitted = (event: {
    type: string;
    message: string;
    title: string;
  }) => {
    const raw = event.message as unknown;
    let message = "";
    if (typeof raw === "string") {
      message = raw;
    } else if (raw != null && typeof raw === "object") {
      const obj = raw as Record<string, unknown>;
      if (typeof obj.message === "string") message = obj.message;
      else if (typeof obj.msg === "string") message = obj.msg;
      else message = event.title || "Success";
    } else if (raw != null) {
      message = String(raw);
    }

    // Never show "[object Object]" in the toast
    if (message === "[object Object]") {
      message = event.title || "Success";
    }

    this.setState({
      showNotification: true,
      variant: event.type || strings.success,
      title: event.title || "",
      message: message || event.title || "",
    });
    this.scheduleHide(4);
  };

  render() {
    return (
      <CustomNotification
        showNotification={this.state.showNotification}
        verticalPosition="bottom"
        horizontalPosition="center"
        variant={this.state.variant}
        title={this.state.title}
        message={this.state.message}
        handleClose={this.handleClose}
      />
    );
  }
}

export default Notifications;
